import { BaseIcon } from "@/shared/ui/BaseIcons";
import {
  Badge,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Link } from "@tanstack/react-router";
import { memo } from "react";
import type { SidebarLinkType } from "../model";

export type SidebarListItemProps = {
  isActive: boolean;
  onClick?: () => void;
} & SidebarLinkType;

export const SidebarListItem = memo(
  ({
    href,
    text,
    icon,
    isActive,
    badgeNumber,
    onClick,
  }: SidebarListItemProps) => {
    const fontColor = isActive ? "primary.main" : "grey.500";
    const bgColor = isActive ? "#E1F5EF" : "transparent";
    return (
      <ListItem
        component={href ? Link : "div"}
        to={href}
        disablePadding
        sx={{
          px: 2,
          my: 1,
          borderRight: {
            xs: "none",
            sm: isActive ? "3px solid #52A48B" : "3px solid transparent",
          },
          borderLeft: {
            xs: isActive ? "3px solid #52A48B" : "3px solid transparent",
            sm: "none",
          },
        }}
      >
        <ListItemButton
          onClick={onClick}
          disableRipple
          draggable={false}
          sx={{
            border: "1px solid",
            borderColor: "transparent",
            borderRadius: "16px",
            fontWeight: 700,
            backgroundColor: bgColor,
            "&:hover": {
              backgroundColor: "#E1F5EF",
            },
            "&:focus": {
              backgroundColor: "#E1F5EF",
            },
            "& MuiTypography-root": {
              fontWeight: 700,
            },
          }}
        >
          <ListItemIcon color="primary">
            <BaseIcon name={icon} sx={{ color: fontColor }} />
          </ListItemIcon>
          <ListItemText
            primary={text}
            primaryTypographyProps={{
              sx: {
                fontWeight: 700,
                color: fontColor,
                fontSize: "16px",
              },
            }}
          />
          {badgeNumber && (
            <Badge
              badgeContent={badgeNumber}
              color="primary"
              sx={{
                right: 8,
              }}
              slotProps={{
                badge: {
                  style: {
                    fontSize: 14,
                    fontWeight: 700,
                    minWidth: 24,
                    height: 24,
                    lineHeight: 24,
                    borderRadius: "50%",
                  },
                },
              }}
            />
          )}
        </ListItemButton>
      </ListItem>
    );
  },
);
